(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dts-category-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dts-scroll-row')) {
    class DtsScrollRow extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-dts-track]');
        this.prev = this.querySelector('[data-dts-row-prev]');
        this.next = this.querySelector('[data-dts-row-next]');
        if (!this.track) return;
        const step = () => {
          const card = this.track.firstElementChild;
          return card ? card.getBoundingClientRect().width * Math.max(1, Math.floor(this.track.clientWidth / card.getBoundingClientRect().width) - 1) : this.track.clientWidth;
        };
        if (this.prev) this.prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
        if (this.next) this.next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
        this.update = this.update.bind(this);
        this.track.addEventListener('scroll', this.update, { passive: true });
        window.addEventListener('resize', this.update);
        this.update();
      }
      disconnectedCallback() {
        window.removeEventListener('resize', this.update);
      }
      update() {
        const max = this.track.scrollWidth - this.track.clientWidth - 2;
        if (this.prev) this.prev.disabled = this.track.scrollLeft <= 2;
        if (this.next) this.next.disabled = this.track.scrollLeft >= max;
      }
    }
    customElements.define('dts-scroll-row', DtsScrollRow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dts-header"]) return;
  try {
    
  (function () {
    function init(root) {
      root.querySelectorAll('[data-dts-autosubmit]').forEach(function (el) {
        el.addEventListener('change', function () { el.form && el.form.submit(); });
      });
      root.querySelectorAll('[data-dts-close-drawer]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var d = btn.closest('details');
          if (d) d.removeAttribute('open');
        });
      });
      root.querySelectorAll('.dts-hd__cats-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var wrap = btn.parentElement;
          var open = wrap.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    }

    function formatMoney(cents, format) {
      var value = (cents || 0) / 100;
      function group(n, dec, thou, decSep) {
        var parts = n.toFixed(dec).split('.');
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
        return parts.join(decSep);
      }
      var match = format && format.match(/\x7b\x7b\s*(\w+)\s*\x7d\x7d/);
      if (!match) return group(value, 2, ',', '.');
      var out;
      switch (match[1]) {
        case 'amount_no_decimals': out = group(value, 0, ',', '.'); break;
        case 'amount_with_comma_separator': out = group(value, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': out = group(value, 0, '.', ','); break;
        case 'amount_with_apostrophe_separator': out = group(value, 2, "'", '.'); break;
        case 'amount_no_decimals_with_space_separator': out = group(value, 0, ' ', ','); break;
        case 'amount_with_space_separator': out = group(value, 2, ' ', ','); break;
        case 'amount_with_period_and_space_separator': out = group(value, 2, ' ', '.'); break;
        default: out = group(value, 2, ',', '.');
      }
      return format.replace(match[0], out);
    }

    var refreshTimer = null;
    function refreshCart() {
      clearTimeout(refreshTimer);
      refreshTimer = setTimeout(function () {
        var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.querySelectorAll('[data-dts-cart-count]').forEach(function (el) {
              el.textContent = cart.item_count;
              el.classList.remove('is-bumped');
              void el.offsetWidth;
              el.classList.add('is-bumped');
            });
            document.querySelectorAll('[data-dts-cart-total]').forEach(function (el) {
              el.textContent = formatMoney(cart.total_price, el.getAttribute('data-money-format'));
            });
          })
          .catch(function () {});
      }, 150);
    }

    /* Horizon fires 'shopify:cart:lines-update' with a promise that resolves when the cart is saved. */
    function onCartEvent(e) {
      if (e && e.promise && typeof e.promise.then === 'function') {
        e.promise.then(refreshCart, refreshCart);
      } else {
        refreshCart();
      }
    }

    init(document);
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
    ['shopify:cart:lines-update', 'cart:update', 'cart:updated', 'cart:refresh'].forEach(function (name) {
      document.addEventListener(name, onCartEvent);
    });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refreshCart(); });
    document.addEventListener('click', function (e) {
      document.querySelectorAll('.dts-hd__cats.is-open').forEach(function (wrap) {
        if (!wrap.contains(e.target)) {
          wrap.classList.remove('is-open');
          var b = wrap.querySelector('.dts-hd__cats-btn');
          if (b) b.setAttribute('aria-expanded', 'false');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dts-hero-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dts-hero-slider')) {
    class DtsHeroSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.dts-hero__track');
        this.slides = Array.from(this.querySelectorAll('.dts-hero__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-dts-dot]'));
        this.index = 0;
        this.editorPaused = false;

        const prev = this.querySelector('[data-dts-prev]');
        const next = this.querySelector('[data-dts-next]');
        if (prev) prev.addEventListener('click', () => { this.go(this.index - 1); this.restart(); });
        if (next) next.addEventListener('click', () => { this.go(this.index + 1); this.restart(); });
        this.dots.forEach((dot, i) => dot.addEventListener('click', () => { this.go(i); this.restart(); }));

        this.addEventListener('mouseenter', () => this.stop());
        this.addEventListener('mouseleave', () => this.start());
        this.addEventListener('focusin', () => this.stop());
        this.addEventListener('focusout', () => this.start());

        let startX = null;
        this.addEventListener('pointerdown', (e) => { startX = e.clientX; }, { passive: true });
        this.addEventListener('pointerup', (e) => {
          if (startX === null) return;
          const dx = e.clientX - startX;
          startX = null;
          if (Math.abs(dx) > 45) { this.go(this.index + (dx < 0 ? 1 : -1)); this.restart(); }
        });

        this.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.indexOf(e.target.closest('.dts-hero__slide'));
          if (i > -1) { this.editorPaused = true; this.stop(); this.go(i, true); }
        });
        this.addEventListener('shopify:block:deselect', () => { this.editorPaused = false; this.start(); });

        this.go(0, true);
        this.start();
      }

      disconnectedCallback() { this.stop(); }

      go(i, instant) {
        const n = this.slides.length;
        if (!n) return;
        this.index = (i + n) % n;
        if (instant) this.track.style.transition = 'none';
        this.track.style.transform = 'translateX(' + this.index * -100 + '%)';
        if (instant) { void this.track.offsetWidth; this.track.style.transition = ''; }
        this.slides.forEach((s, k) => {
          const active = k === this.index;
          s.classList.toggle('is-active', active);
          s.setAttribute('aria-hidden', active ? 'false' : 'true');
          s.inert = !active;
        });
        this.dots.forEach((d, k) => {
          if (k === this.index) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      }

      start() {
        if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.editorPaused) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        this.stop();
        this.timer = setInterval(() => this.go(this.index + 1), parseInt(this.dataset.interval, 10) || 5000);
      }

      stop() { clearInterval(this.timer); }

      restart() { this.stop(); this.start(); }
    }
    customElements.define('dts-hero-slider', DtsHeroSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
